import { ConvertPoundsToNearestFiveKilograms } from 'functions/measurementSystemUtils'

import MiniLinearDial from 'components/Dials/MiniLinearDial'

export default function WorkoutSummaryExerciseSetListItem({
    completed,
    exerciseName,
    exerciseType,
    setIndex,
    setsAssigned,
    setUnit,
    repsAssigned,
    setUnitsCompleted,
    weightRecommendation,
    weightRecommendationRounded,
}) {

    const measurementSystem = 'imperial' // TODO: Load from backend?

    return (
        <div className="py-4 pl-4 pr-2 bg-gray-100">

            {/* Title */}
            <p className="pb-4">{exerciseName}</p>

            <div className={`
                grid grid-cols-9
                ${completed ? 'opacity-100' : 'opacity-40'}
            `}>

                {/* Set Number */}
                <div className="flex items-center font-extrabold text-gray-600 gap-x-0.5">
                    <span className="text-2xl font-semibold">{setIndex + 1}</span>
                    <span className='text-sm font-semibold'>/</span>
                    <span className="text-sm font-semibold">{setsAssigned}</span>
                </div>

                {/* Load Recommendation */}
                <div className="px-0.5 col-span-2 flex items-center justify-center">

                    {completed && 
                        <>

                            {/* Recommendation */}
                            {exerciseType === 'recommendation' && (
                                <div className="flex-grow text-center py-1 text-sm">
                                    {measurementSystem === 'imperial' && <>{weightRecommendationRounded} lbs</>}
                                    {measurementSystem === 'metric' && <>{ConvertPoundsToNearestFiveKilograms(weightRecommendation)} kgs</>}
                                </div>
                            )}

                            {/* Bodyweight */}
                            {exerciseType === 'bodyweight' && 
                                <div className="flex-grow text-center py-1 text-sm">
                                    Body
                                </div>
                            }

                        </>
                    }

                    {!completed && 
                        <div className="flex-grow text-center py-1 text-sm">
                            --
                        </div>
                    }

                </div>

                {/* Reps Completed */}
                <div className="mr-3 col-span-6 flex items-center justify-center">
                    <MiniLinearDial label={setUnitsCompleted + ' / ' + repsAssigned + ' ' + setUnit} fillPercentage={(setUnitsCompleted / repsAssigned) * 100} />
                </div>
            </div>

        </div>
    )
}
